/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ConsistencyScoreGoalResponse } from './ConsistencyScoreGoalResponse';
import type { RequirementFulfillmentResponse } from './RequirementFulfillmentResponse';

/**
 * Consistency score result for a member
 */
export type ConsistencyScoreResultResponse = {
    /**
     * The calculated consistency score (0-100)
     */
    score: number;
    /**
     * The type of score used
     */
    type: ConsistencyScoreResultResponse.type;
    /**
     * The status based on the score
     */
    status: ConsistencyScoreResultResponse.status;
    /**
     * The set of goals with their current counts
     */
    goals: Array<ConsistencyScoreGoalResponse>;
    /**
     * The set of requirement fulfillments with their thresholds
     */
    requirementFulfillments: Array<RequirementFulfillmentResponse>;
};

export namespace ConsistencyScoreResultResponse {

    /**
     * The type of score used
     */
    export enum type {
        EVERNORTH = 'EVERNORTH',
        HWJ = 'HWJ',
    }

    /**
     * The status based on the score
     */
    export enum status {
        PERFECT = 'PERFECT',
        GOOD = 'GOOD',
        MEDIUM = 'MEDIUM',
        LOW = 'LOW',
        NONE = 'NONE',
    }


}

